import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/**
 * Opponent as page config. EntityPage summarises created and modified in the footer.
 */
export const opponentPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "dwopponent",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: fullWidth,
          blocks: [
            {
              kind: "section",
              id: "section-opponent",
              // The page bar already names the record.
              title: "",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: thirdWidth,
                },
                {
                  id: "field-opponenttypeid",
                  type: "lookup",
                  name: "opponenttypeid",
                  label: "Opponent Type",
                  lookupEntity: "dwopponenttype",
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
